import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-unit-details-header-controls-year',
  templateUrl: './unit-details-header-controls-year.component.html',
  styleUrls: ['./unit-details-header-controls-year.component.scss'],
})
export class UnitDetailsHeaderControlsYearComponent {
  @Output() year_change: EventEmitter<number> = new EventEmitter<number>();

  years: number[] = [];
  current_year: number = new Date().getUTCFullYear();

  ngOnInit(): void {
    const start: number = new Date().getUTCFullYear();
    const end: number = 2050;
    this.years = [];
    for (let i = start; i <= end; i++) {
      this.years.push(i);
    }
  }

  onYearClick(year: number): void {
    this.current_year = year;
    this.year_change.emit(this.current_year);
  }
}
